(function () {
  'use strict';

  var COOKIE_NAME = 'tt_consent';
  var COOKIE_DAYS = 395;

  function getCookie(name) {
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(name + '=') === 0) {
        try {
          return JSON.parse(decodeURIComponent(part.slice(name.length + 1)));
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + '=' + encodeURIComponent(JSON.stringify(value)) +
      ';expires=' + date.toUTCString() +
      ';path=/;SameSite=Lax';
  }

  var banner   = document.getElementById('tt-cookie-banner');
  var backdrop = document.getElementById('tt-cookie-backdrop');
  var compact  = document.getElementById('tt-cookie-compact');
  var panel    = document.getElementById('tt-cookie-panel');

  if (!banner) return;

  function showBanner() {
    banner.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.classList.add('tt-cookie-visible');
      });
    });
  }

  function hideBanner() {
    banner.classList.remove('tt-cookie-visible');
    if (backdrop) backdrop.setAttribute('hidden', '');
    banner.classList.remove('tt-cookie-panel-open');
    banner.addEventListener('transitionend', function handler() {
      banner.removeEventListener('transitionend', handler);
      banner.setAttribute('hidden', '');
    }, { once: true });
  }

  function openPanel() {
    if (compact) compact.setAttribute('hidden', '');
    if (panel) panel.removeAttribute('hidden');
    if (backdrop) backdrop.removeAttribute('hidden');
    banner.classList.add('tt-cookie-panel-open');
    var firstFocusable = panel ? panel.querySelector('button:not([disabled])') : null;
    if (firstFocusable) firstFocusable.focus();
  }

  function closePanel() {
    if (panel) panel.setAttribute('hidden', '');
    if (compact) compact.removeAttribute('hidden');
    if (backdrop) backdrop.setAttribute('hidden', '');
    banner.classList.remove('tt-cookie-panel-open');
  }

  function getToggle(category) {
    return panel ? panel.querySelector('[data-category="' + category + '"]') : null;
  }

  function getToggleState(category) {
    var toggle = getToggle(category);
    return toggle ? toggle.getAttribute('aria-checked') === 'true' : false;
  }

  function setToggleState(category, state) {
    var toggle = getToggle(category);
    if (toggle) toggle.setAttribute('aria-checked', state ? 'true' : 'false');
  }

  function signalShopifyConsent(analytics, marketing, callback) {
    var cb = typeof callback === 'function' ? callback : function () {};
    var consent = (analytics && marketing) ? true
                : { marketing: !!marketing, analytics: !!analytics, preferences: true, sale_of_data: false };

    function doSet() {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {
          console.log('[TT Consent] setTrackingConsent sent:', consent);
          cb();
        });
      } else {
        console.log('[TT Consent] customerPrivacy unavailable after loadFeatures');
        cb();
      }
    }

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{
        name: 'consent-tracking-api',
        version: '0.1',
        onLoad: function () {
          console.log('[TT Consent] consent-tracking-api loaded');
          doSet();
        }
      }]);
    } else {
      console.log('[TT Consent] loadFeatures not available, trying direct');
      doSet();
    }
  }

  function saveConsent(analytics, marketing) {
    setCookie(COOKIE_NAME, {
      necessary: true,
      analytics: !!analytics,
      marketing: !!marketing,
      timestamp: new Date().toISOString()
    }, COOKIE_DAYS);
    hideBanner();
    signalShopifyConsent(analytics, marketing, function () {
      if (analytics) loadAnalytics();
      if (marketing) loadMarketing();
    });
  }

  function loadAnalytics() {
  }

  function loadMarketing() {
    if (loadMarketing.subscribed) return;
    loadMarketing.subscribed = true;

    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input instanceof Request ? input.url : '');
      var isAdd = url.indexOf('/cart/add') !== -1;
      var promise = _fetch.apply(this, arguments);
      if (!isAdd) return promise;
      return promise.then(function (response) {
        if (!response.ok) return response;
        response.clone().json().then(function (data) {
          var item = data.variant_id ? data : (data.items && data.items[0]) || null;
          if (!item) return;
          if (window.Shopify && window.Shopify.analytics) {
            window.Shopify.analytics.publish('collection_page_add_to_cart', {
              productVariantId: String(item.variant_id),
              price:            typeof item.final_price === 'number' ? item.final_price / 100 : 0,
              currency:         'EUR'
            });
            console.log('[TT Pixel] Shopify.analytics.publish collection_page_add_to_cart:', item.variant_id);
          }
        }).catch(function () {});
        return response;
      });
    };
  }

  var toggleBtns = panel ? panel.querySelectorAll('.tt-cookie-toggle:not(.tt-cookie-toggle--locked)') : [];
  for (var i = 0; i < toggleBtns.length; i++) {
    toggleBtns[i].addEventListener('click', function () {
      var current = this.getAttribute('aria-checked') === 'true';
      this.setAttribute('aria-checked', current ? 'false' : 'true');
    });
  }

  var btnManage       = document.getElementById('tt-btn-manage');
  var btnRefuse       = document.getElementById('tt-btn-necessary');
  var btnAccept       = document.getElementById('tt-btn-accept');
  var btnSave         = document.getElementById('tt-btn-save');
  var btnRefusePanel  = document.getElementById('tt-btn-refuse-panel');
  var btnAcceptPanel  = document.getElementById('tt-btn-accept-panel');

  if (btnManage)      btnManage.addEventListener('click', openPanel);
  if (btnRefuse)      btnRefuse.addEventListener('click', function () { saveConsent(false, false); });
  if (btnAccept)      btnAccept.addEventListener('click', function () { saveConsent(true, true); });
  if (btnRefusePanel) btnRefusePanel.addEventListener('click', function () {
    setToggleState('analytics', false);
    setToggleState('marketing', false);
    saveConsent(false, false);
  });
  if (btnAcceptPanel) btnAcceptPanel.addEventListener('click', function () {
    setToggleState('analytics', true);
    setToggleState('marketing', true);
    saveConsent(true, true);
  });
  if (btnSave) btnSave.addEventListener('click', function () {
    saveConsent(getToggleState('analytics'), getToggleState('marketing'));
  });

  if (backdrop) backdrop.addEventListener('click', function () {
    closePanel();
  });

  document.addEventListener('keydown', function (e) {
    if (!banner.classList.contains('tt-cookie-visible')) return;

    if (e.key === 'Escape') {
      if (panel && !panel.hasAttribute('hidden')) {
        closePanel();
      } else {
        hideBanner();
      }
      return;
    }

    if (e.key === 'Tab' && panel && !panel.hasAttribute('hidden')) {
      var focusable = Array.prototype.slice.call(
        panel.querySelectorAll('button:not([disabled])')
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  window.openCookiePreferences = function () {
    var stored = getCookie(COOKIE_NAME);
    if (stored) {
      setToggleState('analytics', !!stored.analytics);
      setToggleState('marketing', !!stored.marketing);
    }
    if (banner.hasAttribute('hidden')) {
      showBanner();
    }
    openPanel();
  };

  var stored = getCookie(COOKIE_NAME);
  if (stored) {
    signalShopifyConsent(stored.analytics, stored.marketing, function () {
      if (stored.analytics) loadAnalytics();
      if (stored.marketing) loadMarketing();
    });
  } else {
    signalShopifyConsent(false, false);
    showBanner();
  }

})();
